module.exports = "<nb-layout>\n\t<nb-layout-column>\n\t\t<ng-content select=\"router-outlet\"></ng-content>\n\t</nb-layout-column>\n</nb-layout>\n"